/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".bg-grey[_ngcontent-%COMP%]{background-color:grey}.rainbow-text[_ngcontent-%COMP%]{background-image:linear-gradient(270deg,violet,indigo,blue,green,#ff0,orange,red);-webkit-background-clip:text;color:transparent}"];
export { styles as styles };

